import Login from './Login';
import Loading from './Loading';
import { useContext } from 'react';
import UserContext from '../contexts/UserContext';

const SecureRoute = ({ oktaAuthenticated, msAuthenticated, loading, children}) => {

    const userContext = useContext(UserContext)
    
    let authenticated = false

    if(loading){
        return <Loading />
    }

    if(msAuthenticated || oktaAuthenticated){
        authenticated = true
    }
    if(userContext.userInfo && authenticated){
        return children
    }
    return <Login />
}

export default SecureRoute